$('.tile-info__txt a').on('click', function (event) {
    event.stopPropagation();
});
